import { environment } from '@/environments/environment';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { Adjunto } from '@/app/models/interface/adjunto.model';
import {
  NoProgramada,
  NoProgramadaInstructor,
} from '@/app/models/interface/no-programadas.model';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class NoProgramadaService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'no-programada/';

  create(data: FormData) {
    return this.http.post<CustomResponse<NoProgramada>>(this.url, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  findAll(params?: Params) {
    return this.http
      .get<
        CustomResponse<PaginatorModel<NoProgramada[], HasPagination>>
      >(this.url, { params })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          if (d && Array.isArray(d.data)) {
            return {
              ...d,
              data: d.data.map((d) => ({
                ...d,
                instructores: d.instructores.map(
                  (instructor) =>
                    (instructor as NoProgramadaInstructor).usuario,
                ),
              })),
            };
          }
          return d;
        }),
      );
  }

  findOne(id: string) {
    const url = this.url + id;
    return this.http.get<CustomResponse<NoProgramada>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        if (d) {
          const usuarios =
            d.participantes?.map((participante) => participante.usuario) || [];
          return {
            ...d,
            usuarios,
          };
        }
        return d;
      }),
    );
  }

  update(item: Partial<NoProgramada>) {
    const url = this.url + item.id;
    return this.http.put<CustomResponse<NoProgramada>>(url, item).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        if (d) {
          return {
            ...d,
          };
        }
        return d;
      }),
    );
  }

  uploadArchivos(formData: FormData, id: string) {
    const dir = this.url + 'newArchivos/' + id;
    return this.http.post<CustomResponse<Adjunto[]>>(dir, formData).pipe(
      catchError((err) => handleError(err)),
      map((data) => data.result),
    );
  }
}
